// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f33e8355b9ce3128bf472b0e0d8b25b802520f8a/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};